import { useEffect, useState } from 'react'
import html from 'html-react-parser'
import { useTranslation } from 'next-i18next'
import { Fade } from 'react-awesome-reveal'
import { css } from '@emotion/react'

import { unOrphan } from '@/utils/orphans'
import { slugify } from '@/utils/common'

import { FaqItem } from '@/service'
import { getNavigationIcon } from '@/constants/navigationAssets'

import CustomReveal from '@/components/common/CustomReveal'
import Link from '@/components/common/Link'
import { Grid } from '@/styles/grid'

import {
  Breadcrumbs,
  ButtonWrapper,
  Container,
  LinkContent,
  NoResults,
  Text,
  TextNoResults,
  Title,
  Wrapper
} from './SearchList.styled'

interface Props {
  results: FaqItem[]
}

function SearchList(props: Props) {
  const { results } = props
  const { t } = useTranslation('faq')
  const LOAD_MORE_VALUE = 6
  const [showMore, setShowMore] = useState(LOAD_MORE_VALUE)

  const showMoreResults = () => {
    setShowMore(showMore + LOAD_MORE_VALUE)
  }

  useEffect(() => {
    setShowMore(LOAD_MORE_VALUE)
  }, [results])

  return (
    <Fade triggerOnce>
      <Wrapper>
        <Grid>
          <Container id="categories-section">
            {results.length ? (
              <>
                {results.slice(0, showMore).map(el => (
                  <CustomReveal key={slugify(el.title)}>
                    <Link
                      href={{
                        pathname: '/faq/[category]',
                        query: { category: el.categoryUrlSlug },
                        hash: `#${slugify(el.title)}`
                      }}
                      passHref
                    >
                      <LinkContent>
                        <Title>{el.title}</Title>
                        <Breadcrumbs>
                          {t('breadcrumbsIn')} {t('breadcrumbs')} /{' '}
                          {el.category}
                        </Breadcrumbs>
                        <Text>{html(unOrphan(el.content))}</Text>
                      </LinkContent>
                    </Link>
                  </CustomReveal>
                ))}
                {results.length > showMore && (
                  <ButtonWrapper
                    type="button"
                    onClick={showMoreResults}
                    text={t('search.buttonMoreResults')}
                  />
                )}
              </>
            ) : (
              <NoResults>
                <img
                  src={getNavigationIcon('noResults')}
                  alt="No results found"
                  css={noResultsStyle}
                  loading="lazy"
                />
                <TextNoResults>{html(t('search.noResults'))}</TextNoResults>
              </NoResults>
            )}
          </Container>
        </Grid>
      </Wrapper>
    </Fade>
  )
}

const noResultsStyle = css`
  width: 86px;
  height: 86px;
`

export default SearchList
